import dayjs from "dayjs";

import { Option } from "@/@types/generics/Option";
import { Department } from "@/@types/sintegrada/Department";
import { HospitalWard } from "@/@types/sintegrada/HospitalWard";

const startDate = dayjs().add(-1, "month").startOf("day").format("YYYY-MM-DDTHH:mm");
const endDate = dayjs().endOf("day").format("YYYY-MM-DDTHH:mm");

export const hospitalizationFilterInitialValues = {
	startDate,
	endDate,
	minAge: "",
	maxAge: "",
	department: {} as Option<Department>,
	hospitalWard: {} as Option<HospitalWard>,
};

export type TypeofHospitalizationFilterInitialValues = typeof hospitalizationFilterInitialValues;
